import React from 'react';

import { Component as Landmark } from '../layout/Landmark.jsx';

function Animation(props) {
    const [animate, setAnimate] = React.useState(false);
    const handleEnter = () => {
        setAnimate(true)
    }
    React.useEffect(() => {
        if (props.builder) {
            setAnimate(true);
        }
    }, []);
    const style = { opacity: 0, transform: 'translateY(100px)' };
    if (animate) {
        style.opacity = 1;
        style.transform = 'translateY(0)';
        style.transition = `all 1000ms ease-out ${Math.random() * 500}ms`
    }
    return (
        <>
            <Landmark useWindow={true} onEnter={handleEnter} />
            <div style={style}>
                {props.children}
            </div>
        </>
    );
}

function Column(props) {
    let className = 'col';
    if (props.size) {
        className += ` col--${props.size}`;
    }
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (props.inline) {
        return (
            <span className={className}>
                {props.children}
            </span>
        );
    }
    return (
        <div className={className} id={props.id} style={props.style}>
            {props.children}
        </div>
    );
}

function Container(props) {
    let className = 'cont';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (props.spaced == true) {
        className += ' cont--spaced';
    }
    return (
        <div className={className} id={props.id} style={props.style}>
            {props.children}
        </div>
    );
}

function HeaderText(props) {
    let className = 'typ--main';
    if (props.className) {
        className += ` ${props.className}`;
    }
    let innerClassName = 'typ--main__inn';
    if (props.innerClassName) {
        innerClassName += ` ${props.innerClassName}`;
    }
    return (
        <h1 className={className} style={props.style}>
            <div className={innerClassName}>{props.children}</div>
        </h1>
    );
}

function NotFound() {
    const handleBack = (e) => {
        if (e) {
            e.preventDefault()
        }
        window.history.back();
        return false;
    }
    return (
        <div className="cont">
            <p className="show__card__text center">
                <React.Fragment>
                    The page you are looking for could not be found. Please click <a href="#" onClick={handleBack}>here</a> to return to the last page you were viewing.
                </React.Fragment>
            </p>
        </div>
    );
}

function Row(props) {
    let className = 'cont__row';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <div className={className} id={props.id} style={props.style}>
            {props.children}
        </div>
    );
}

function Spaced(props) {
    let className = 'cont--spaced';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (props.large) {
        className += ' cont--spaced--lg';
    }
    return (
        <div className={className} style={props.style}>
            {props.children}
        </div>
    );
}

function withHoverColorChange(WrappedComponent) {
    return (props) => {
        const handleChange = (e) => {
            if (!e || !e.currentTarget) {
                return;
            }
            const backgroundColor = e.currentTarget.style.backgroundColor;
            const borderBottomColor = e.currentTarget.style.borderBottomColor;
            const borderBottomStyle = e.currentTarget.style.borderBottomStyle;
            const borderBottomWidth = e.currentTarget.style.borderBottomWidth;
            const borderColor = e.currentTarget.style.borderColor;
            const borderLeftColor = e.currentTarget.style.borderLeftColor;
            const borderLeftStyle = e.currentTarget.style.borderLeftStyle;
            const borderLeftWidth = e.currentTarget.style.borderLeftWidth;
            const borderRadius = e.currentTarget.style.borderTopLeftRadius;
            const borderRightColor = e.currentTarget.style.borderRightColor;
            const borderRightStyle = e.currentTarget.style.borderRightStyle;
            const borderRightWidth = e.currentTarget.style.borderRightWidth;
            const borderTopColor = e.currentTarget.style.borderTopColor;
            const borderTopStyle = e.currentTarget.style.borderTopStyle;
            const borderTopWidth = e.currentTarget.style.borderTopWidth;
            const fontStyle = e.currentTarget.style.fontStyle;
            const opacity = e.currentTarget.style.opacity;
            const textDecoration = e.currentTarget.style.textDecoration;

            let color = e.currentTarget.style.color;
            let elementText = e.currentTarget.getElementsByClassName('button-content');
            if (elementText && elementText.length > 0) {
                elementText = elementText[0];
                color = elementText.style.color;
            } else {
                elementText = undefined;
            }

            let elementDefault, elementHover;
            if (props.hoverProps) {
                elementHover = e.currentTarget.getElementsByClassName('link-hover');
                if (elementHover && elementHover.length > 0) {
                    elementHover = elementHover[0]
                    elementHover.className = `button-content link-hover link-active${props.contentClassName ? ` ${props.contentClassName}` : ''}`;

                    elementDefault = e.currentTarget.getElementsByClassName('link-default');
                    if (elementDefault && elementDefault.length > 0) {
                        elementDefault = elementDefault[0]
                        elementDefault.className = `button-content link-default${props.contentClassName ? ` ${props.contentClassName}` : ''}`;
                    } else {
                        elementDefault = undefined;
                    }
                } else {
                    elementHover = undefined;
                }
            }
            const reset = (e2) => {
                if (!e2 || !e2.target) {
                    return;
                }
                if (e2.toElement && e2.toElement.className && e2.toElement.className.indexOf && e2.toElement.className.indexOf('button-content') >= 0) {
                    e2.target.blur();
                    return;
                }
                e2.target.style.backgroundColor = backgroundColor || '';
                e2.target.style.borderBottomColor = borderBottomColor || '';
                e2.target.style.borderBottomLeftRadius = borderRadius || '';
                e2.target.style.borderBottomRightRadius = borderRadius || '';
                e2.target.style.borderBottomStyle = borderBottomStyle || '';
                e2.target.style.borderBottomWidth = borderBottomWidth || '';
                e2.target.style.borderLeftColor = borderLeftColor || '';
                e2.target.style.borderLeftStyle = borderLeftStyle || '';
                e2.target.style.borderLeftWidth = borderLeftWidth || '';
                e2.target.style.borderRightColor = borderRightColor || '';
                e2.target.style.borderRightStyle = borderRightStyle || '';
                e2.target.style.borderRightWidth = borderRightWidth || '';
                e2.target.style.borderTopColor = borderTopColor || '';
                e2.target.style.borderTopLeftRadius = borderRadius || '';
                e2.target.style.borderTopRightRadius = borderRadius || '';
                e2.target.style.borderTopStyle = borderTopStyle || '';
                e2.target.style.borderTopWidth = borderTopWidth || '';
                e2.target.style.fontStyle = fontStyle || '';
                e2.target.style.color = color || '';
                e2.target.style.opacity = opacity || '';
                e2.target.style.textDecoration = textDecoration || '';

                if (elementText) {
                    elementText.style.color = color;
                }
                if (elementDefault) {
                    elementDefault.className = `button-content link-default link-active${props.contentClassName ? ` ${props.contentClassName}` : ''}`;
                }
                if (elementHover) {
                    elementHover.className = `button-content link-hover${props.contentClassName ? ` ${props.contentClassName}` : ''}`;
                }
            }
            e.currentTarget.onblur = reset;
            e.currentTarget.onmouseout = reset;
            e.currentTarget.onmousedown = reset;

            if (e.currentTarget.tagName == 'SELECT') {
                e.currentTarget.onchange = reset;
                e.currentTarget.oninput = reset;
            }

            const hoverProps = props.hoverProps || {};
            e.currentTarget.style.backgroundColor = hoverProps.backgroundColor || backgroundColor;
            e.currentTarget.style.borderBottomLeftRadius = hoverProps.borderRadius || borderRadius;
            e.currentTarget.style.borderBottomRightRadius = hoverProps.borderRadius || borderRadius;
            e.currentTarget.style.borderTopLeftRadius = hoverProps.borderRadius || borderRadius;
            e.currentTarget.style.borderTopRightRadius = hoverProps.borderRadius || borderRadius;
            e.currentTarget.style.color = hoverProps.color || color;
            e.currentTarget.style.opacity = hoverProps.opacity || opacity;

            if (fontStyle || hoverProps.fontStyle) {
                e.currentTarget.style.fontStyle = hoverProps.fontStyle || '';
            }
            if (textDecoration || hoverProps.textDecoration) {
                e.currentTarget.style.textDecoration = hoverProps.textDecoration || '';
            }

            if (hoverProps.borderColor) {
                e.currentTarget.style.borderColor = hoverProps.borderColor || borderColor;
            } else {
                e.currentTarget.style.borderBottomColor = hoverProps.borderBottomColor || borderBottomColor;
                e.currentTarget.style.borderBottomStyle = hoverProps.borderBottomStyle || borderBottomStyle;
                e.currentTarget.style.borderBottomWidth = hoverProps.borderBottomWidth || borderBottomWidth;
                e.currentTarget.style.borderLeftColor = hoverProps.borderLeftColor || borderLeftColor;
                e.currentTarget.style.borderLeftStyle = hoverProps.borderLeftStyle || borderLeftStyle;
                e.currentTarget.style.borderLeftWidth = hoverProps.borderLeftWidth || borderLeftWidth;
                e.currentTarget.style.borderRightColor = hoverProps.borderRightColor || borderRightColor;
                e.currentTarget.style.borderRightStyle = hoverProps.borderRightStyle || borderRightStyle;
                e.currentTarget.style.borderRightWidth = hoverProps.borderRightWidth || borderRightWidth;
                e.currentTarget.style.borderTopColor = hoverProps.borderTopColor || borderTopColor;
                e.currentTarget.style.borderTopStyle = hoverProps.borderTopStyle || borderTopStyle;
                e.currentTarget.style.borderTopWidth = hoverProps.borderTopWidth || borderTopWidth;
            }
        }
        return <WrappedComponent {...props} onFocus={handleChange} onMouseOver={handleChange}>{props.children}</WrappedComponent>
    }
}

export {
    Animation,
    Column,
    Container,
    HeaderText,
    NotFound,
    Row,
    Spaced,
    withHoverColorChange
};